import './App.css';
import { Routes, Route } from "react-router-dom";
import NoteState from './Context/notes/NoteState';
import Login from './Components/Login';
import SignUp from './Components/SignUp';
import ForgotPass from './Components/ForgotPass';

// NEW DESIGN SYSTEM
import { NewHomePage } from './pages/NewHomePage';
import { LandingPage } from './pages/LandingPage';
import { AdminDashboard } from './pages/AdminDashboard';

function App() {
  return (
    <div>
      <NoteState>
        <div className='flex flex-col min-h-screen'>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/dashboard" element={<NewHomePage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/signin" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/forgotpass" element={<ForgotPass />} />
          </Routes>
        </div>
      </NoteState>
    </div>
  );
}

export default App;
